export const formatCategory = (categories: any[]) => {
  const orderedCategories: any = [];
  const groupedCategories = (categories || [])
    .filter((c: any) => c.parentCategoryId === "") // parent category
    .map((c: any) => ({
      ...c,
      subCategory: categories
        .filter(
          (sC: any) => sC.parentCategoryId === c.id // sub Category
        )
        .map((cS: any) => ({
          ...cS,
          subCategory: categories.filter(
            (sC: any) => sC.parentCategoryId === cS.id
          ),
        })), // subSub category
    }));

  groupedCategories.forEach((gc: any) => {
    orderedCategories.push({ ...gc, type: "parent", parents: [] });
    gc.subCategory.forEach((sc: any) => {
      orderedCategories.push({ ...sc, type: "sous-cat", parents: [gc.id] });
      sc.subCategory.forEach((ssc: any) => {
        orderedCategories.push({
          ...ssc,
          type: "sous-sous-cat",
          parents: [gc.id, sc.id],
        });
      });
    });
  });
  return { groupedCategories, orderedCategories };
};

export default formatCategory;
